import { NavLink } from 'react-router-dom';

const TABS = [
  { to: '/audiobooks', label: 'Books',  icon: '\u266B' },
  { to: '/music',      label: 'Music',  icon: '\u266A' },
  { to: '/movies',     label: 'Movies', icon: '\u25B6' },
  { to: '/videos',     label: 'Videos', icon: '\u25A0' },
  { to: '/photos',     label: 'Photos', icon: '\u25C6' },
];

export default function BottomTabBar() {
  return (
    <nav className="FV-bottomtab">
      {TABS.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            `FV-bottomtab-item${isActive ? ' FV-bottomtab-item--active' : ''}`
          }
        >
          <span className="FV-bottomtab-icon">{tab.icon}</span>
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
